<template>
    <div class="card-wrap">
        <van-nav-bar title="我的证件/My documents" v-if="userInfo.idCardType != '外商证'"></van-nav-bar>

        <div class="auditing  ql-snow" v-if="isAuditing == 1 && userInfo.status == 0">
            <div class="app-content ql-editor" v-html="app.auditSuccess"></div>
            <div class="go-home" @click="loginOut">
                <p>
                    返回首页
                </p>
            </div>
        </div>

        <div class="auditing  ql-snow" v-else-if="isAuditing == 1 && userInfo.status == 2">
            <div class="app-content ql-editor" v-html="app.auditRefuse"></div>
            <div class="go-home" @click="loginOut">
                <p>
                    返回首页
                </p>
            </div>
        </div>

        <div class="main" v-else>
            <div class="code-wrap">
                <ticket-code v-if="!app.timingCode" :user-info="userInfo" :appData="app" />
                <dynamic-code v-else :user-info="userInfo" :appData="app" />

            </div>

            <!-- 邀请好友 -->
            <div class="menu" v-if="userInfo.idCardType != '外商证'">
                <div class="menu-item" @click="handleLink(item)" v-for="(item,index) in app.menus" :key="index">
                    <img :src="item.icon" alt="" />
                    <span>{{item.name}}</span>
                </div>
            </div>
        </div>

        <!-- 分享海报 -->
        <share-poster ref="shareRef" :user="userInfo"></share-poster>
    </div>
</template>

<script>
import httpRequest from '@/module_visitor/api/http.js';
import Toast from 'vant/lib/toast';
import SharePoster from './share';
import DynamicCode from './dynamic';
import TicketCode from './code';
import { mapGetters } from 'vuex';
import wx from 'weixin-js-sdk';
export default {
    data() {
        return {
            upUserInfo: false,
            waitHsVerify: false,
            form: {
                name: '',
                idCard: '',
            },
            shareShow: false,
            tel: '',
            userInfo: {
                name: '',
                code: '',
                photo: '',
                url: '',
                idCard: '',
                id: 0,
            },
            isHsStatusY: true,
            show: false,
            hsTime: undefined,
            refresh: 0,
            timer: null,
            count: 60,
            app: {},
            localInfo: null,
        };
    },
    components: {
        SharePoster,
        TicketCode,
        DynamicCode,
    },
    created() {
        this.init();
    },
    computed: {
        ...mapGetters(['defaultInfo']),
        isAuditing() {
            return this.defaultInfo.config.isAuditing;
        },
        primaryBg() {
            return { background: this.defaultInfo.config.primaryColor };
        },
        primaryColor() {
            return { color: this.defaultInfo.config.primaryColor };
        },
    },
    methods: {
        async init() {
            await this.handleGetUserInfo(0);

            httpRequest.get(`/api/TActivity/Info`).then(res => {
                const { code, data } = res.data;
                if (code == 200) {
                    this.localInfo = JSON.parse(data.address);
                }
            });
        },

        getLocation() {
            var local = this.localInfo;
            if (!local) {
                Toast('定位未配置，请联系工作人员');
                return;
            }
            wx.openLocation({
                latitude: local.latlng.lat, // 纬度，浮点数，范围为90 ~ -90
                longitude: local.latlng.lng, // 经度，浮点数，范围为180 ~ -180。
                name: local.poiname, // 位置名
                address: local.poiaddress, // 地址详情说明
                scale: 18, // 地图缩放级别,整型值,范围从1~28。默认为最大
                infoUrl: '', // 在查看位置界面底部显示的超链接,可点击跳转
            });
        },

        // 微信分参数
        getconfig() {
            let url = location.href.split('#')[0]; //获取锚点之前的链接

            httpRequest
                .get(`/api/visitor/GetJsApiTicket`, {
                    url: url,
                })
                .then(res => {
                    const { data, code, msg } = res.data;
                    if (code == 200) {
                        this.wxinit(data);
                    }
                });
        },

        // 微信分享
        wxinit(res) {
            let links = window.location.href;
            let title = this.userInfo.name + '邀请您参观' + this.defaultInfo.config.name;
            let desc =
                '时间：' + this.defaultInfo.config.startTime + '\r\n' + '地点：' + this.defaultInfo.config.address;
            let imgurl = this.defaultInfo.config.shareImg;
            wx.config({
                debug: false,
                appId: res.appId,
                timestamp: parseInt(res.timestamp),
                nonceStr: res.nonceStr,
                signature: res.signature,
                jsApiList: [
                    'checkJsApi',
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
                    'onMenuShareAppMessage',
                    'openLocation',
                ],
            });
            wx.ready(function () {
                wx.updateTimelineShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: links, // 分享链接
                    imgUrl: imgurl, // 分享图标
                    success: function (res) {},
                });
                wx.updateAppMessageShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: links, // 分享链接
                    imgUrl: imgurl, // 分享图标
                    success: function () {},
                    cancel: function () {},
                });
                wx.onMenuShareAppMessage({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: links, // 分享链接
                    imgurl: imgurl, // 分享图标
                    success: function () {},
                    cancel: function () {},
                });
            });
        },

        handleGetConfig(moduleType) {
            httpRequest.get(`/api/ConfigPage/getModule?module=${moduleType}`).then(res => {
                const { code, data } = res.data;

                if (code == 200) {
                    if (data) {
                        var pageInfo = data;
                        var pageData = JSON.parse(pageInfo.pageData);
                        pageData.content = this.replaceContent(pageData.content);
                        pageData.prompt = this.replaceContent(pageData.prompt);
                        pageData.title = this.replaceContent(pageData.title);
                        this.app = pageData;
                    }
                }
            });
        },

        replaceContent(value) {
            if (value)
                return value
                    .replace('{title}', this.defaultInfo.config.name)
                    .replace('{company}', this.userInfo.company ? this.userInfo.company : '')
                    .replace('{createTime}', this.userInfo.createTime ? this.userInfo.createTime : '')
                    .replace('{position}', this.userInfo.position ? this.userInfo.position : '')
                    .replace('{code}', this.userInfo.code ? this.userInfo.code : '')
                    .replace('{name}', this.userInfo.name ? this.userInfo.name : '')
                    .replace('{booth}', this.userInfo.booth ? this.userInfo.booth : '')
                    .replace('{idCardType}', this.userInfo.idCardType ? this.userInfo.idCardType : '');
        },

        handleUpdate(refresh) {
            this.handleGetUserInfo(refresh);
        },

        handleLink(item) {
            let link = item.link.replace('/', '');

            if (link == 'local') {
                this.getLocation();
                return;
            }

            if (link == 'login' || link == 'register' || link == 'event' || link == 'forum') {
                this.$router.push({
                    path: item.link,
                    query: {
                        source: this.$route.query.source,
                        companyId: this.$route.query.companyId,
                        companyShareId: this.$route.query.companyShareId,
                        teamId: this.$route.query.teamId,
                    },
                });
                return;
            }

            if (item.link == 'share') {
                this.onShare();
            } else if (link.indexOf('http') > -1) {
                window.location.href = item.link;
            } else {
                this.$router.push({
                    path: item.link,
                    query: {
                        item: item,
                    },
                });
            }
        },

        back() {
            var { config } = this.defaultInfo;
            const page = config.homeUrl || '/login';

            this.$router.push(page);
        },

        onUpHsImg() {
            this.$refs.upHsImgRef.open();
        },

        /** 退出登录 */
        loginOut() {
            var { config } = this.defaultInfo;

            const page = config.homeUrl || '/login';
            this.$router.push(page);
        },

        /** 分享海报 */
        onShare() {
            this.$refs.shareRef.open();
        },

        onRank() {
            this.$router.push('/invite');
        },

        handleGetUserInfo(refresh) {
            Toast.loading({
                message: '数据加载中...',
                forbidClick: true,
                loadingType: 'spinner',
            });
            httpRequest
                .get(`/api/visitor/getInfo`, {
                    refresh: refresh,
                    tel: this.$route.query.tel,
                    code: this.$route.query.code,
                })
                .then(res => {
                    const { code, data, msg } = res.data;
                    this.shareShow = true;
                    if (code == 200) {
                        this.userInfo = data;
                        var moduleType = data.identitys == '1' ? 'result' : 'resultExhibitor';
                        this.handleGetConfig(moduleType);
                        this.getconfig();
                    } else {
                        var { config } = this.defaultInfo;
                        const page = config.homeUrl || '/login';
                        this.$router.push({
                            path: page,
                            query: {
                                source: this.$route.query.source,
                                companyId: this.$route.query.companyId,
                                companyShareId: this.$route.query.companyShareId,
                                teamId: this.$route.query.teamId,
                            },
                        });
                    }
                })
                .catch(error => {})
                .finally(() => {
                    Toast.clear();
                });
        },

        onSubmit() {
            this.userInfo.idCard = this.form.idCard;
            this.userInfo.name = this.form.name;
            httpRequest.put(`/api/visitor`, this.userInfo).then(res => {
                if (res.data.code == 200) {
                    this.upUserInfo = false;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.card-wrap {
    height: 100%;
    background: #f8f8f8;
    overflow: scroll;
    .go-home {
        display: flex;
        justify-content: center;
        p {
            padding: 12px;
            color: #5475ff;
            background: #fff;
            border: 1px solid #5475ff;
            margin: 20px auto;
        }
    }
    .auditing {
        padding-top: 80px;
        display: flex;
        flex-direction: column;
        align-items: center;
        svg {
            width: 100px;
            height: 100px;
            color: #5475ff;
        }
        .a-text {
            margin-top: 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            span {
                color: #5475ff;
            }
        }
    }

    .main {
        position: relative;

        .code-wrap {
            padding: 24px 24px 0 24px;
        }
        .menu {
            .menu-item {
                img {
                }
                span {
                    color: #333;
                    margin-top: 2px;
                    font-size: 14px;
                }
            }
        }

        .share {
            background: #fff;
            padding: 10px;
            border-radius: 4px;
            margin: 10px 0;
            display: flex;
            justify-content: space-around;
            border-radius: 10px;

            .share-item {
                color: #5475ff;
                border-radius: 4px;
                padding: 10px;
                font-size: 32px;
                display: flex;
                flex-direction: column;
                align-items: center;

                span {
                }
            }
        }

        .icon {
            font-size: 24px;
        }
    }

    .menu {
        padding: 10px;
        border-radius: 4px;
        margin: 10px 0;
        display: flex;
        justify-content: space-around;
        border-radius: 10px;
        margin: 0 20px;

        .menu-item {
            color: #5475ff;
            border-radius: 4px;
            padding: 4px;
            font-size: 16px;
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1;

            .menu-txt {
            }

            .menu-icon {
                font-size: 50px;
            }

            img {
                width: 100%;
                height: auto;
            }
        }

        .menu-item {
            .menu-txt {
            }
        }
    }
}
</style> 